var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaIncLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 20,
    viewBox: "0 0 59 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00579F",
    d: "M25.542 18.801L20.767 18.801 23.754.335 28.529.335zM42.852.786C41.91.413 40.416 0 38.569 0c-4.715 0-8.036 2.514-8.056 6.11-.04 2.652 2.377 4.125 4.184 5.01 1.848.903 2.476 1.493 2.476 2.298-.02 1.237-1.493 1.808-2.868 1.808-1.906 0-2.928-.294-4.48-.983l-.629-.295-.668 4.146c1.12.51 3.183.963 5.326.982 5.01 0 8.271-2.475 8.31-6.306.02-2.102-1.257-3.713-4.008-5.03-1.67-.844-2.693-1.414-2.693-2.278.02-.786.865-1.591 2.75-1.591 1.553-.04 2.693.333 3.557.707l.432.196.65-3.988zM49.198 12.26c.393-1.062 1.906-5.168 1.906-5.168-.02.04.393-1.08.628-1.768l.334 1.592s.904 4.42 1.1 5.343h-3.968zM55.092.334h-3.694c-1.139 0-2.004.333-2.495 1.532L41.81 18.8h5.01l1.002-2.77h6.131c.137.648.57 2.77.57 2.77h4.42L55.093.335zM16.78.335l-4.677 12.592-.51-2.554c-.865-2.947-3.577-6.148-6.602-7.74l4.283 16.149h5.049L21.828.335H16.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAA61A",
    d: "M7.76.335H.08L0 .708c5.993 1.532 9.961 5.226 11.592 9.666l-1.67-8.487C9.647.707 8.802.374 7.761.335z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIncLogo);
export default __webpack_public_path__ + "static/media/visa-inc-logo.c56a50171b8b58e78b1e7a902a93fcc8.svg";
export { ForwardRef as ReactComponent };